// Content structure for High Five Access legal pages.
// Each doc has: slug, docNumber, title, accentWord, intro, chapters[], updated.

export const LEGAL_DOCS = [
  {
    slug: "privacy",
    docNumber: "01",
    label: "Privacy Policy",
    title: "Privacy Policy",
    accentWord: "responsibly",
    intro:
      "At High Five Access, we value your privacy and are committed to handling your information responsibly.",
    chapters: [
      {
        heading: "Information We Collect",
        body: [
          "We may collect basic personal and professional information that you voluntarily share while applying for membership, communicating with us, or using our website and services.",
        ],
      },
      {
        heading: "How We Use Your Information",
        body: ["Your information is used to:"],
        list: [
          "Review membership applications.",
          "Onboard members.",
          "Communicate important updates and information.",
          "Improve the member experience and community operations.",
          "Maintain the quality and integrity of High Five Access.",
        ],
      },
      {
        heading: "Information Sharing",
        body: [
          "High Five Access does not sell your personal information to third parties.",
          "We may share information only where required by applicable law or when necessary to operate and improve our services through trusted service providers.",
        ],
      },
      {
        heading: "Data Security",
        body: [
          "We take reasonable measures to protect the information you share with us. While no online system can guarantee absolute security, we continuously strive to safeguard your information.",
        ],
      },
      {
        heading: "Changes to This Policy",
        body: [
          "This Privacy Policy may be updated from time to time to reflect improvements to our services or legal requirements. The latest version will always be available on this page.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any privacy-related questions, please contact us through the Contact Us page.",
        ],
      },
    ],
  },
  {
    slug: "terms",
    docNumber: "02",
    label: "Terms & Conditions",
    title: "Terms & Conditions",
    accentWord: "welcome",
    intro:
      "Welcome to High Five Access. By accessing or using our website, services, or community, you agree to these Terms & Conditions.",
    chapters: [
      {
        heading: "Membership",
        body: [
          "High Five Access is a curated professional community designed to help members build meaningful professional relationships through conversations, collaborations, and shared opportunities.",
        ],
      },
      {
        heading: "Community Conduct",
        body: [
          "Members are expected to interact respectfully, professionally, and responsibly while participating in the community, events, and discussions.",
        ],
      },
      {
        heading: "Responsible Use",
        body: [
          "Users are expected to use the website and community in good faith and in accordance with applicable laws.",
          "Activities that disrupt the experience of other members or misuse the platform are not permitted.",
        ],
      },
      {
        heading: "Intellectual Property",
        body: [
          "The High Five Access name, logo, website content, branding, and original materials are the intellectual property of High Five Access and may not be copied, reproduced, or distributed without prior permission.",
        ],
      },
      {
        heading: "Community Evolution",
        body: [
          "As High Five Access continues to grow, certain features, services, membership benefits, events, or policies may evolve over time to better serve the community.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any questions regarding these Terms & Conditions, please contact us through the Contact Us page.",
        ],
      },
    ],
  },
  {
    slug: "refund",
    docNumber: "03",
    label: "Refund Policy",
    title: "Refund Policy",
    accentWord: "fair",
    intro:
      "High Five Access aims to provide a transparent and fair membership experience.",
    chapters: [
      {
        heading: "Membership Fee",
        body: [
          "Membership fees are non-refundable once membership has been granted.",
        ],
      },
      {
        heading: "Application Review & Refunds",
        body: [
          "Every membership application is reviewed individually. If an application is not accepted, the membership fee paid for that application will be refunded.",
          "Once an application has been accepted and membership has been granted, the membership fee is non-refundable, including if a member later chooses to leave the community.",
        ],
      },
      {
        heading: "Membership Termination",
        body: [
          "Membership may be terminated if a member fails to follow the HFA Community Guidelines. In such cases, no refund will be provided.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For payment-related questions or refund-related queries, please reach out through the Contact Us page.",
        ],
      },
    ],
  },
];

export function getLegalDoc(slug) {
  return LEGAL_DOCS.find((d) => d.slug === slug);
}

export function getLegalNeighbors(slug) {
  const i = LEGAL_DOCS.findIndex((d) => d.slug === slug);
  const total = LEGAL_DOCS.length;
  return {
    prev: LEGAL_DOCS[(i - 1 + total) % total],
    next: LEGAL_DOCS[(i + 1) % total],
    total,
  };
}
